<template>
  <div class="app-main-content">
    <div v-show="!showAccountingDocument && !accountingDocumentWindow.visible" class="grid-view">
      <div v-show="!showAccountingDocument && !accountingDocumentWindow.visible" class="main-content accounting-document-list">
        <el-form :inline="true" label-position="left">
          <el-row :gutter="5" type="flex" style="margin-top: 8px">
            <el-col>
              <div class="app-main-inner-row operations" style="padding: 0; justify-content: flex-start;">
                <div class="triggers">
                  <div>
                    <!--查询-->
                    <el-button no="1" type="primary" @click="doSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                    <!--新增-->
                    <el-button no="2" type="primary" plain @click="doAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
                    <!--复制-->
                    <el-button no="copy" type="primary" plain @click="doCopy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
                    <!--审核-->
                    <el-button v-if="$checkPermission(['button_AccountingDocumentCheck'])" no="3" :disabled="!reviewBtnEnabled" type="primary" plain @click="reviewHandler">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
                    <!--反审核-->
                    <el-button v-if="$checkPermission(['button_AccountingDocumentUncheck'])" no="4" :disabled="!unreviewBtnEnabled" type="primary" plain @click="unreviewHandler">{{ $t('CargoMsg.Cargo_ReverseReview') }}</el-button>
                    <!--批量删除-->
                    <el-button v-if="$checkPermission(['button_AccountingDocumnetDelete'])" no="5" :disabled="!batchDeleteBtnEnabled" type="primary" plain @click="deleteClickHandler">{{ $t('CargoMsg.Cargo_BatchDelete') }}</el-button>
                    <!--批量打印-->
                    <el-button no="6" :disabled="!batchPrintBtnEnabled" type="primary" plain @click="batchExcelBtnClickHandler">{{ $t('CargoMsg.Cargo_BatchPrint') }}</el-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col>
              <div class="app-main-inner-row" style="padding: 0; height: 25px;">
                <span style="position: absolute; right: 10px; margin-top: 5px;">
                  <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
                </span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="5" type="flex" style="margin-top: 12px">
            <div class="app-main-inner-row operations" style="padding: 0; justify-content: flex-start;">
              <!--会计期间-->
              <el-form-item :label="$t('CargoMsg.Cargo_FiscalPeriod')" label-width="70px" class="el-form-item">
                <el-select v-model="form.fpSelect" no="7" style="width: 110px">
                  <el-option
                    v-for="(item,index) in fpSelectDataProvider"
                    :key="index"
                    :label="fiscalPeriodLabelFun(item)"
                    :value="item.uuid"
                  />
                </el-select>
              </el-form-item>
              <!--凭证字-->
              <el-form-item :label="$t('CargoMsg.Cargo_VoucherLetter')" label-width="70px" class="el-form-item" style="word-break: break-all; white-space: normal;">
                <el-select v-model="form.prefix" no="8" style="width: 70px">
                  <el-option
                    v-for="item in prefixDDL"
                    :key="item.name"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <!--凭证号-->
              <el-form-item :label="$t('CargoMsg.Cargo_NumberS')" label-width="20px">
                <el-input-number
                  v-model="form.startDocumentNo"
                  no="9"
                  :min="0"
                  :precision="0"
                  style="width:80px;"
                  :controls="false"
                  @blur="e => { if (e.target.value <= 0) form.startDocumentNo = undefined }"
                />
              </el-form-item>
              <el-form-item label="-" label-width="20px">
                <el-input-number
                  v-model="form.endDocumentNo"
                  no="10"
                  :min="0"
                  :precision="0"
                  style="width:80px;"
                  :controls="false"
                  @blur="e => { if (e.target.value <= 0) form.endDocumentNo = undefined }"
                />
              </el-form-item>
              <!--凭证日期-->
              <el-form-item :label="$t('CargoMsg.Cargo_ProofDate')" label-width="60px">
                <el-date-picker
                  v-model="form.startDate"
                  no="11"
                  type="date"
                  style="width:100px;"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_To')" label-width="24px">
                <el-date-picker
                  v-model="form.endDate"
                  no="12"
                  type="date"
                  style="width:100px;"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                />
              </el-form-item>
              <!--凭证状态-->
              <el-form-item :label="$t('CargoMsg.Cargo_VoucherStatus')" label-width="60px">
                <el-select v-model="form.state" no="13" filterable style="width:80px;">
                  <el-option
                    v-for="item in FinanceInterfaceConstants.VOUCHER_STATES2"
                    :key="item.code"
                    :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-row>
          <el-row :gutter="5" type="flex" style="margin-top: 12px">
            <div class="app-main-inner-row operations" style="padding: 0; justify-content: flex-start;">
              <!--制单人-->
              <el-form-item :label="$t('CargoMsg.Cargo_PreparedBy')" label-width="70px" style="word-break: break-all; white-space: normal;">
                <cargo-user-select
                  no="14"
                  style="width:150px;"
                  :method-params="{officeId:$store.getters.currentOfficeId,category:'role'}"
                  :default-value="form.documentMaker||''"
                  @change="p=>{form.documentMaker = p.value}"
                />
              </el-form-item>
              <!--审核人-->
              <el-form-item :label="$t('CargoMsg.Cargo_Auditor')" label-width="60px">
                <cargo-user-select
                  no="15"
                  style="width:150px;"
                  :method-params="{officeId:$store.getters.currentOfficeId,category:'role'}"
                  :default-value="form.verifier||''"
                  @change="p=>{form.verifier = p.value}"
                />
              </el-form-item>
              <!--录入人-->
              <el-form-item :label="$t('CargoMsg.Cargo_CreatedBy')" label-width="60px">
                <cargo-user-select
                  no="16"
                  style="width:150px;"
                  :method-params="{officeId:$store.getters.currentOfficeId,category:'role'}"
                  :default-value="form.createdBy||''"
                  @change="p=>{form.createdBy = p.value}"
                />
              </el-form-item>
              <!--修改人-->
              <el-form-item :label="$t('CargoMsg.Cargo_Modifier')" label-width="60px" style="word-break: break-all; white-space: normal;">
                <cargo-user-select
                  no="17"
                  style="width:150px;"
                  :method-params="{officeId:$store.getters.currentOfficeId,category:'role'}"
                  :default-value="form.modifiedBy||''"
                  @change="p=>{form.modifiedBy = p.value}"
                />
              </el-form-item>
              <!--录入时间-->
              <el-form-item :label="$t('CargoMsg.Cargo_InputTime')" label-width="60px">
                <el-date-picker
                  v-model="form.dateCreatedStart"
                  no="18"
                  type="date"
                  style="width:100px;"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_To')" label-width="24px">
                <el-date-picker
                  v-model="form.dateCreatedEnd"
                  no="19"
                  type="date"
                  style="width:100px;"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                />
              </el-form-item>
            </div>
          </el-row>
        </el-form>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="6000001"
            :column-defs="columnDefs"
            :grid-options="gridOptions"
            :grid-params.sync="girdParams"
            :row-data="rowData"
            style="height: 800px;"
          />
        </div>
        <div class="pagination-wrapper" style="padding-right:0px;">
          <cargo-pagination
            config-module="6000000"
            :limit.sync="page.pageSize"
            :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
            :page.sync="page.pageNum"
            :total="page.total"
            @pagination="doSearch"
          />
        </div>
      </div>
    </div>
    <!--    编辑用-->
    <accounting-document
      v-if="showAccountingDocument"
      ref="accountingDocumentWin"
      :current-account-set="accountSet"
      :voucher-index="voucherIndex"
      :voucher-list="rowData"
      type="edit"
      @cancel="showAccountingDocument=false"
    />
    <!--    复制用-->
    <accounting-document
      v-if="accountingDocumentWindow.visible"
      ref="accountingDocumentCopy"
      :current-account-set="accountSet"
      :voucher-index="accountingDocumentWindow.voucherIndex"
      :voucher-list="accountingDocumentWindow.rowData"
      :type="accountingDocumentWindow.type"
      @cancel="accountingDocumentCallBack"
    />
    <!-- 选择账套 -->
    <account-set-popup
      ref="refAccountSetPopup"
      :mode="accountSetPopup.mode"
      :visible.sync="accountSetPopup.visible"
      :load-accounting-document-type-flag="false"
      :load-mapping-departments-flag="false"
      :load-mapping-staffs-flag="false"
      :load-accounting-documents-rule-flag="false"
      :load-current-rates-flag="true"
      :sort-fiscal-period-desc="true"
      @cancel="()=>accountSetPopup.visible=false"
      @select="data=>accountSet=data"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :visible.sync="templateSelectorDialog.visible"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import AccountingDocument from '@/views/cargo/v0/FinanceManage/AccountingDocument/index'
import * as accountingDocumentApi from '@/api/financeManage/accountingDocument'
import * as accountingDocumentTypeApi from '@/api/financeManage/accountingDocumentType'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import { cache } from '@/utils/cacheManager'
import { DocumentManage } from '@/utils/commonUtil'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import VoucherUtils from '@/utils/VoucherUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { User } from '@/class/model/sys/User'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'AccountingDocumentList',
  components: { CargoUserSelect, AccountSetPopup, AccountingDocument, cargoTemplateSelectorDialog },
  data() {
    return {
      prefixDDL: [],
      FinanceInterfaceConstants: FinanceInterfaceConstants,
      documentManage: new DocumentManage(),
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.itemCheckHandler(event.data)
        },
        onCellDoubleClicked: event => {
          if (event.data && event.data.uuid) {
            this.editHandler(event.data.uuid)
          }
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false

        }, {
          headerName: this.$t('CargoMsg.Cargo_VoucherLetter'),
          field: 'prefix',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
          field: 'documentNo',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ProofDate'),
          field: 'documentDate',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Annual'),
          field: 'year',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_Periods'),
          field: 'month',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_Appendix'),
          field: 'sourceDocument',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreparedBy'),
          field: 'documentMaker',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Auditor'),
          field: 'verifier',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedBy'),
          field: 'createdBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InputTime'),
          field: 'dateCreated',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Modifier'),
          field: 'modifiedBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ModificationTime'),
          field: 'dateModified',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          width: 100,
          sortable: false,
          cellRenderer: params => {
            console.log('params')
            console.log(params)
            const editHandler = this.documentManage.getPath('editHandler')
            const deleteButtonClickHandler = this.documentManage.getPath('deleteButtonClickHandler')
            return `&nbsp;&nbsp;&nbsp;<a onclick="${editHandler}('${params.data.uuid}')" style="color:#46a6ff">${this.$t('common.btn.edit')}</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a onclick="${deleteButtonClickHandler}('${params.data.uuid}')" style="color:#ff4646">${this.$t('common.btn.delete')}</a>`
          }
        }
      ],
      rowData: [],
      voucherIndex: null,
      form: {
        prefix: LocalStorageUtilsNew.getConfiguration('AccountingDocumentList_formPrefix', 'string') || null,
        startDocumentNo: undefined,
        endDocumentNo: undefined,
        state: null,
        startDate: '',
        endDate: '',
        dateCreatedStart: '',
        dateCreatedEnd: '',
        fpSelect: null
      },
      page: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      templateSelectorDialog: {
        visible: false,
        category: '',
        data: {}
      },
      fpSelectDataProvider: [],
      accountSet: null,
      accountSetPopup: { visible: false, mode: 'office' },
      reviewBtnEnabled: false,
      accountingDocumentWindow: {
        visible: false,
        type: 'copy',
        rowData: [],
        voucherIndex: null
      },
      footerData: [{
        summary: '',
        debitAmount: 0,
        crebitAmount: 0
      }],
      unreviewBtnEnabled: false,
      batchDeleteBtnEnabled: false,
      batchPrintBtnEnabled: false,
      showAccountingDocument: false
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    }
  },
  watch: {
    async accountSet(newVal) {
      const prefixDDL = [
        { name: this.$t('CargoMsg.Cargo_All'), value: null },
        { name: this.$t('CargoMsg.Cargo_Collect'), value: this.$t('CargoMsg.Cargo_Collect') },
        { name: this.$t('CargoMsg.Cargo_Pay'), value: this.$t('CargoMsg.Cargo_Pay') },
        { name: this.$t('CargoMsg.Cargo_Transfer'), value: this.$t('CargoMsg.Cargo_Transfer') },
        { name: '*', value: '*' }
      ]
      if (newVal) {
        this.fpSelectDataProvider = this.accountSet.fiscalPeriod // await fiscalPeriodApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
        if (this.accountSet.currentFiscalPeriod) this.form.fpSelect = this.accountSet.currentFiscalPeriod.uuid
        if (newVal.uuid) {
          await accountingDocumentTypeApi.query({ accountingSetKey: newVal.uuid }).then(res => {
            const uniqueSet = new Set()
            for (const row of res.data.list) {
              if (row.prefix && row.prefix !== this.$t('CargoMsg.Cargo_Collect') && row.prefix !== this.$t('CargoMsg.Cargo_Pay') &&
                row.prefix !== this.$t('CargoMsg.Cargo_Transfer') && row.prefix !== '*') {
                uniqueSet.add(row.prefix)
              }
            }
            for (const prefix of uniqueSet) {
              prefixDDL.push({ name: prefix, value: prefix })
            }
          }).catch(() => {})
        }
      }
      this.prefixDDL = prefixDDL
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('deleteButtonClickHandler', function(data) {
      self.deleteButtonClickHandler(data)
    })
    this.documentManage.set('editHandler', function(data) {
      self.editHandler(data)
    })
  },
  created() {
    this.selectAccountSetHandler()
  },
  beforeDestroy() {
    if (this.form.prefix) {
      LocalStorageUtilsNew.setConfiguration('AccountingDocumentList_formPrefix', this.form.prefix)
    }
  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return this.$t('FinanceManage.N0Year0Period', [data.year, data.month])
      }
      return ''
    },
    // 选择账套
    selectAccountSetHandler() {
      this.accountSetPopup.visible = true
    },
    doSearch() {
      const condition = {}
      for (const key in this.form) {
        if (key !== 'fpSelect' && (this.form[key] || this.form[key] === 0)) {
          condition[key] = this.form[key]
        }
      }
      if (this.form.fpSelect) {
        const fiscalperiod = this.fpSelectDataProvider.find(fp => fp.uuid === this.form.fpSelect)
        condition.year = fiscalperiod.year
        condition.month = fiscalperiod.month
      }
      const params = {}
      params.condition = condition
      params.accountingSetKey = this.accountSet.uuid
      params.pageSize = this.page.pageSize
      params.pageNum = this.page.pageNum
      const loading = getLoading()
      accountingDocumentApi.query(params).then(resp => {
        this.page.total = Number(resp.data.total)
        this.page.pageSize = resp.data.pageSize
        this.page.pageNum = resp.data.pageNum
        this.rowData = resp.data.list
      }).finally(() => loading.close())
    },
    doAdd() {
      this.$router.replace('/FinanceManage/AccountingDocument')
    },
    async doCopy() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      const uuids = rows.map(row => row.uuid)
      if (uuids.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyOneVoucherForCopy'))
        return
      }
      this.accountingDocumentWindow.rowData = [... this.rowData]
      const accountingDocument = this.accountingDocumentWindow.rowData.find(row => row.uuid === uuids[0])
      if (accountingDocument) {
        this.accountingDocumentWindow.voucherIndex = this.rowData.findIndex(row => row.uuid === accountingDocument.uuid)
      }
      if (!await this.checkCopy(accountingDocument)) {
        return
      }
      this.accountingDocumentWindow.visible = true
    },
    async checkCopy(accountingDocument) {
      let voucher = this.accountingDocumentWindow.rowData[this.accountingDocumentWindow.voucherIndex]
      if (voucher) {
        voucher = await accountingDocumentApi.detail({ uuid: voucher.uuid }).then(resp => resp.data)
      }
      const types = ['debitAmount', 'crebitAmount']
      types.forEach(type => {
        this.footerData[0][type] = voucher.accountingEntry.reduce((total, item) => {
          total += isNaN(item[type]) ? 0 : item[type]
          total = NumberUtils.roundHalfUp4(total)
          return total
        }, 0)
      })
      const footerRow = this.footerData[0]
      // 业务生成的凭证借贷方金额合不能改变
      if (accountingDocument.businessDataType !== 999) {
        if (accountingDocument.debitTotal !== footerRow.debitTotal ||
          accountingDocument.creditTotal !== footerRow.creditTotal) {
          this.$message.warning(this.$t('FinanceManage.ThisVoucherPleaseEditInModule'))
          return false
        }
      }
      return true
    },
    accountingDocumentCallBack() {
      this.doSearch()
      this.accountingDocumentWindow.visible = false
    },
    reviewHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      const list = []
      for (const accountingDocument of rows) {
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.fpSelectDataProvider)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (!accountingDocument.verifier) {
          const index = list.findIndex(key => key === accountingDocument.uuid)
          if (index < 0) {
            list.push(accountingDocument.uuid)
          }
        }
      }
      if (list.length === 0) return
      this.batchApproveOrNot(list, true)
    },
    // 判断当前凭证日期是否结账
    checkVoucherDateClosing(voucherDateStr, fiscalPeriods) {
      if (!voucherDateStr) return false
      const voucherDate = DateUtils.dateToStr(voucherDateStr)
      for (const fiscalPeriod of fiscalPeriods) {
        if (fiscalPeriod.closing && fiscalPeriod.year === voucherDate.fullYear && fiscalPeriod.month === (voucherDate.month + 1)) {
          return true
        }
      }
      return false
    },
    unreviewHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      const list = []
      for (const accountingDocument of rows) {
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.fpSelectDataProvider)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.verifier) {
          const index = list.findIndex(key => key === accountingDocument.uuid)
          if (index < 0) {
            list.push(accountingDocument.uuid)
          }
        }
      }
      if (list.length === 0) return
      this.batchApproveOrNot(list, false)
    },
    async deleteClickHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      for (const accountingDocument of rows) {
        if (accountingDocument.closing) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOPLCOCTBD'))
          return
        }
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.fpSelectDataProvider)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.state === FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyReviewedVouchersCanBeDeleted'))
          return
        }
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTSVRJEWBDTM').format(rows.length), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      })
      const uuids = rows.map(row => row.uuid)
      const loading = getLoading()
      accountingDocumentApi.remove({ accountingKeys: uuids }).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        this.doSearch()
      }).finally(() => loading.close())
    },
    batchExcelBtnClickHandler() {
      if (Number(cache.config.get('queryVoucherExcelExport')) === 1) {
        const rows = this.gridOptions.api.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
          return
        }
        const uids = rows.map(row => row.uuid)
        if (uids.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVoucher'))
          return
        }
        if (uids.length > 100) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectUpToVouchers'))
          return
        }
        const variables = {}
        variables.data = JSON.stringify(uids)
        variables.excelExport = '2'
        variables.tenantId = this.$store.getters.tenantId
        variables.sessionId = getToken()
        variables.accountSetKey = this.accountSet.uuid
        variables.branchName = this.$store.getters.currentOffice.chineseName
        // ExportUtils.voucherExportToExcel(variables)
        const serverUrl = URL.finance.accountingDocument.excelExportByAccountingDocumentSearch + '?sessionId=' + getToken()
        this.navigateToURL(serverUrl, variables)
      } else {
        this.batchPrintBtnClickHandler()
      }
    },
    async navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    batchPrintBtnClickHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      const uids = rows.map(row => row.uuid)
      if (uids.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVoucher'))
        return
      }
      this.templateSelectorDialog.category = 'VOUCHERS'
      this.templateSelectorDialog.data = { 'VOUCHERS_UUID': uids }
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(null, "VOUCHERS", {"VOUCHERS_UUID": uids}, this);
    },
    async deleteButtonClickHandler(accountingDocumentUuid) {
      const accountingDocument = this.rowData.find(row => row.uuid === accountingDocumentUuid)
      if (!accountingDocument) return

      if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.fpSelectDataProvider)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SVSMHBC'))
        return
      }
      if (accountingDocument.state === FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyReviewedVouchersCanBeDeleted'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTSVRJEWBDT'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      })
      const uuids = [accountingDocument.uuid]
      const loading = getLoading()
      accountingDocumentApi.remove({ accountingKeys: uuids }).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        this.doSearch()
      }).finally(() => loading.close())
    },
    editHandler(accountingDocumentUuid) {
      const accountingDocument = this.rowData.find(row => row.uuid === accountingDocumentUuid)
      if (accountingDocument) {
        this.voucherIndex = this.rowData.findIndex(row => row.uuid === accountingDocument.uuid)
      }
      this.showAccountingDocument = true
    },
    itemCheckHandler() {
      if (!this.accountSet) {
        this.reviewBtnEnabled = false
        this.unreviewBtnEnabled = false
        this.batchDeleteBtnEnabled = false
        this.batchPrintBtnEnabled = false
      } else {
        const selectedList = this.gridOptions.api.getSelectedRows()
        if (!selectedList || selectedList.length === 0) {
          this.reviewBtnEnabled = false
          this.unreviewBtnEnabled = false
          this.batchDeleteBtnEnabled = false
          this.batchPrintBtnEnabled = false
        } else {
          this.reviewBtnEnabled = true
          this.unreviewBtnEnabled = true
          this.batchDeleteBtnEnabled = true
          this.batchPrintBtnEnabled = true
        }
      }
    },
    batchApproveOrNot(keys = [], approveOrNot = true) {
      if (!keys || keys.length === 0) return
      const loading = getLoading()
      accountingDocumentApi.verify({ 'accountingKeys': keys, 'state': approveOrNot ? 1 : 0 }).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
        this.doSearch()
      }).finally(() => loading.close())
    }
  }
}
</script>

<style lang="scss">
.accounting-document-list {
  .el-form-item {
    margin-right: 10px !important;
    margin-bottom: 4px !important;
    .el-form-item__content {
      .el-input__inner {
        padding: 0px 5px !important;
      }
      .el-date-editor {
        .el-input__prefix {
          display: none;
        }
      }
    }
  }
}
</style>
